<template>
    <Dialog v-model:visible="showDialog" modal :style="{ width: '750px' }" header="Datasource header" @hide="onHideDialog">
        <div class="grid">
            <div class="form-field col-4">
                <label for="code">Code <span class="mandatory">*</span></label>
                <InputText maxlength = "255" v-model="datasource.code" placeholder="Enter Datasource code" />
            </div>

            <div class="form-field col-6">
                <label for="block-name">Name <span class="mandatory">*</span></label>
                <InputText maxlength = "255" v-model="datasource.name" placeholder="Enter datasource name" />
            </div>

            <div class="form-field col-2">
                <label for="shared_datasource_check">Shared</label>
                <Checkbox
                    :disabled="!datasourceCouldBeShared"
                    id="shared_datasource_check"
                    class="mx-2"
                    v-model="datasource.sharable"
                    :binary="true"
                />
            </div>
            <div v-if="!datasourceCouldBeShared" class="form-field col-12 ">
                <small style="color: rgb(200,0,0);">
                    There is at least one procedure that cannot be applied to a shared Datasource.
                    Please, check the <b>Functional Overview</b>.
                </small>
            </div>

            <div class="form-field col-12">
                <label for="block-name">Description</label>
                <InputText maxlength = "255" v-model="datasource.description" placeholder="Enter datasource description" />
            </div>

        </div>
        <template #footer>
            <div class="flex flex-1 justify-content-end">
                <Button
                    class="mr-2 p-button p-button-success"
                    :disabled="!datasource.name || !datasource.code || saving"
                    type="button"
                    icon="pi pi-save"
                    label="Confirm"
                    :loading="saving"
                    @click="onSaveDatasource"
                />
                <Button
                    class="p-button p-button-warning"
                    :disabled="saving"
                    type="button"
                    icon="pi pi-times"
                    label="Cancel"
                    @click="onHideDialog"
                />
            </div>
        </template>
    </Dialog>
</template>

<script setup>

import { defineEmits, defineProps, onMounted, ref, watch } from 'vue';

const emit = defineEmits(['onSaveDatasource', 'onHideHeaderDialog']);
const props = defineProps({
    showHeaderDialog: {
        type: Boolean,
        required: true
    },
    saving: {
        type: Boolean,
        required: false
    },
    sharable: {
        type: Boolean,
        required: false
    },
    code: {
        type: String,
        required: false
    },
    name: {
        type: String,
        required: false
    },
    description: {
        type: String,
        required: false
    },
    datasourceCouldBeShared: {
        type: Boolean,
        required: false
    },
});

const showDialog = ref(false)

const datasource = ref({
    code: '',
    name: '',
    sharable: false,
    description: '',
})

watch(() => props.showHeaderDialog, (show) => {
    showDialog.value = show
})

watch(() => props.code, (code) => {
    datasource.value.code = code
})

watch(() => props.name, (name) => {
    datasource.value.name = name
})

watch(() => props.sharable, (sharable) => {
    datasource.value.sharable = sharable
})

watch(() => props.description, (description) => {
    datasource.value.description = description
})

watch(() => props.showHeaderDialog, (showHeaderDialog) => {
    showDialog.value = showHeaderDialog
})

onMounted( () => {
    datasource.value.code = props.code
    datasource.value.name = props.name
    datasource.value.sharable = props.sharable
    datasource.value.description = props.description
    showDialog.value = props.showHeaderDialog
})

function onSaveDatasource() {
    emit('onSaveDatasource', datasource.value)
}

function onHideDialog() {
    emit('onHideHeaderDialog')
}

</script>

<style scoped lang="scss">
.form-field {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
}

.form-field label {
    margin-bottom: 0.5rem;
}

.mandatory {
    position: relative;
    top: -0.1em;
    font-size: 80%;
    color: rgb(200, 20, 20);
}
</style>